import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "div-page-content-desc" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "div-page-content-area" }
const _hoisted_5 = { class: "two-button-container" }
const _hoisted_6 = ["disabled"]

import { ref, computed } from "vue";
import { Store } from "vuex";
import { index } from "@/store/index";
import CustomRadioButtonsPreviousTreatment from "@/components/CustomRadioButtonsPreviousTreatment.vue";
import CustomInfoNoteConfirmation from "@/components/CustomInfoNoteConfirmation.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisteringI18nPreviousTreatments',
  emits: ["previousTreatmentsSelected", "cancelRegisteringProcess"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store: Store<unknown> = index;

const showCancelConfirmation = ref<boolean>(false);
const screenPosition = ref<number>(-1);

const justClicked = ref<boolean>(false);
const radioSelected = ref<boolean>();

function radioClicked(clickValue: boolean) {
  radioSelected.value = clickValue;
}

function cancelRegisteringProcess(): void {
  emit("cancelRegisteringProcess");
}

function askCancelProcess(): void {
  screenPosition.value = window.pageYOffset;
  showCancelConfirmation.value = true;
}

function dismissCanceling(): void {
  showCancelConfirmation.value = false;
  // hack because note visibility is made by async items
  setTimeout(scrollBack, 50);
}

function scrollBack(): void {
  if (screenPosition.value > -1) {
    window.scrollTo({ top: screenPosition.value, behavior: "smooth" });
    screenPosition.value = -1;
  }
}

function previousTreatmentsSelected(): void {
  justClicked.value = true;
  emit("previousTreatmentsSelected", radioSelected.value ?? false);
}

const isRadioSelected = computed<boolean>(() => {
  return radioSelected.value !== undefined;
});

const radioSelection = computed<string>(() => {
  if (!isRadioSelected.value) {
    return "";
  } else {
    return radioSelected.value ? "yes" : "no";
  }
});

const radioOptions = computed<string[]>(() => {
  return [
    store.getters.translate("generic-yes"),
    store.getters.translate("generic-no")
  ];
});

return (_ctx: any,_cache: any) => {
  return (showCancelConfirmation.value)
    ? (_openBlock(), _createBlock(CustomInfoNoteConfirmation, {
        key: 0,
        msg: "COMMON-CONFIRMATION",
        title: _unref(store).getters.translate('abort-registering'),
        header: _unref(store).getters.translate('registering-i18n-abort-confirmation'),
        text1: _unref(store).getters.translate('registering-i18n-abort-description'),
        button1: _unref(store).getters.translate('generic-return-b'),
        button2: _unref(store).getters.translate('abort-registering'),
        onCloseNote: dismissCanceling,
        onCancelOrChange: cancelRegisteringProcess
      }, null, 8, ["title", "header", "text1", "button1", "button2"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-previous-treatments")), 1),
          _hoisted_3,
          _createElementVNode("sub", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-previous-treatments-sub")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-previous-treatments-select")), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate(
            "registering-i18n-previous-treatments-select-description"
          )), 1),
          _createVNode(CustomRadioButtonsPreviousTreatment, {
            options: radioOptions.value,
            "previous-selection": radioSelection.value,
            onPreviousTreatmentSelected: radioClicked,
            "yes-first": true
          }, null, 8, ["options", "previous-selection"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "buttonReturn",
              onClick: askCancelProcess
            }, _toDisplayString(_unref(store).getters.translate("generic-abort")), 1),
            _createElementVNode("button", {
              class: "buttonContinue",
              disabled: !isRadioSelected.value || justClicked.value,
              onClick: previousTreatmentsSelected
            }, _toDisplayString(_unref(store).getters.translate("generic-next")), 9, _hoisted_6)
          ])
        ])
      ]))
}
}

})